<mat-card appearance="outlined" [formGroup]="formGroup" class="chart"
          telemetry="Card-PrepaidConsumptionChart-UtilityBilling">
    <mat-card-header fxLayoutAlign="space-between start">
        <mat-card-title>Prepaid Consumption</mat-card-title>

        <lgd-select *ngIf="isLoaded" fxFlex="40" controlName="serviceType" label="Service"
                    [options]="serviceTypesObservable">
        </lgd-select>

        <button mat-icon-button (click)="displayChartParameterDialogAndReload()">
            <mat-icon>settings</mat-icon>
        </button>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="isLoaded" fxLayoutAlign="center stretch">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>

            <div *ngIf="!chartHasData && !errorMessage">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </mat-card-content>
</mat-card>
